import { IGroup } from "@nju/data-access-portal-dashboard";

interface IAllowNewNumberProps {
  groups: IGroup[] | undefined;
}
export function allowNewNumber({ groups }: IAllowNewNumberProps) {
  if (!groups) {
    return false;
  }

  return groups[0].metadata.capacity && groups[0].metadata.capacity > 0;
}
